import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { fuseAnimations } from '@fuse/animations';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { SearchModels } from 'app/models/search-filter.model';
import { User } from 'app/models/user.model';
import { WarnNotification, WarnNotificationSearchModel } from 'app/models/warn-notification.model';
import { WarnNotificationsService } from 'app/services/warn-notification.service';
import { cloneDeep } from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';
import { LastStatusComponent } from '../last-status/last-status.component';

@Component({
    selector: 'warn-notifications',
    templateUrl: './warn-notifications.component.html',
    styleUrls: ['./warn-notifications.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class WarnNotificationsComponent implements OnInit {

    @ViewChild(MatSort) private _sort: MatSort;
    @ViewChild(MatPaginator) private _paginator: MatPaginator;
    public user: User
    public searchModels = new Array<SearchModels>();

    private _filterText: string = '';
    public get filterText(): string {
        return this._filterText;
    }
    public set filterText(v: string) {
        this._filterText = v.trim().toLowerCase();
        this._dataSource.filter = this._filterText;
    }
    public warnNotificationSearchModel=new WarnNotificationSearchModel();

    private _warnNotifications: Array<WarnNotification> = [];

    public get warnNotifications(): Array<WarnNotification> {
        return this._warnNotifications;
    }

    private _dataSource: MatTableDataSource<WarnNotification> = undefined;
    public get dataSource(): MatTableDataSource<WarnNotification> {
        return this._dataSource;
    }

    private _displayedColumns = ['title', 'message','type', 'IsLocationCorrect', 'deviceID', 'createdAt','setting'];

    public get displayedColumns(): Array<string> {
        return this._displayedColumns;
    }

    constructor(
        private _fuseSidebarService: FuseSidebarService,
        private _spinner:NgxSpinnerService,
        private _dialog:MatDialog,
        private datePipe:DatePipe,
        private _warnNotificationService:WarnNotificationsService
    ) {
    }


    public async ngOnInit() {
        await this.getWarnNotificationsList(1,10,"createdAt","desc");
        this.updateTableDataSource();

        var companyId = parseInt(localStorage.getItem('CompanyID'))
        if(companyId!=1){
            this._warnNotificationService.clearWarnReportNotifications(companyId);
        }
    }
    private async getWarnNotificationsList(page?:number,page_size?:number,sort_active?:string,sort_direction?:string): Promise<Array<WarnNotification>> {
        try {
            this._spinner.show('loading')
            this._warnNotifications = await this._warnNotificationService.getWarnNotifications(parseInt(localStorage.getItem("CompanyID")),page,page_size,sort_active,sort_direction,this.searchModels);
            this._spinner.hide('loading')
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);
            return [];
        }
        this.updateTableDataSource();
    }

    public async onLastStatusClick(element:WarnNotification){
        const dialog = this._dialog.open(LastStatusComponent,{
            width:'800px'
        })
        dialog.componentInstance.model = cloneDeep(element)
    }

    public onSearchListen(search_field:any,search_value:any) {
        var index = this.searchModels.findIndex(x=>x.search_field == search_field)
        if(index!=-1){
          this.searchModels.splice(index,1);
        }
        if(search_value!=null && search_value!=""){
            var search = new SearchModels();
            search.search_field=search_field;
            search.search_value = search_value
            if(search_field=="CreatedAt"){
              search.search_value = this.datePipe.transform(search_value, 'yyyy-MM-dd');
            }
            this.searchModels.push(search)
        }
          this.getWarnNotificationsList(this._paginator.pageIndex+1,this._paginator.pageSize,this._sort.active,this._sort.direction)
      }

    private async updateTableDataSource(): Promise<void> {
        this._dataSource = new MatTableDataSource<WarnNotification>(this._warnNotifications);
        this._paginator.length = this._warnNotificationService.count;
    }
    async pageChange(e: any) {
        await this.getWarnNotificationsList(e.pageIndex + 1, e.pageSize,this._sort.active, this._sort.direction)
        await this.updateTableDataSource();
      }
      
  public async sortData(e: any) {
    try {
      await this.getWarnNotificationsList(this._paginator.pageIndex + 1,this._paginator.pageSize, e.active, e.direction);
    } catch (error) {
        this._spinner.hide('loading')
      console.warn(error);
      return [];
    }
    return;
  }
    refresh() {
        this.getWarnNotificationsList();
    }
}
